import { AeraButton } from "@/app/components/ui/AeraButton";

interface ScrollToBottomButtonProps {
    onClick: () => void;
}

export default function ScrollToBottomButton({ onClick }: ScrollToBottomButtonProps) {
    return (
        <AeraButton
            variant="secondary"
            size="xs"
            onClick={onClick}
            paddingSize="none"
            className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 w-8 h-8 transition-all animate-in fade-in"
            aria-label="Scroll to bottom"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 5v14M5 12l7 7 7-7" />
            </svg>
        </AeraButton>
    );
}
